<template>
   <div :class="{'col-12 col-md-6 mb-4':!$props.full}">
      <h1>
         <a class="text-secondary"><slot name="title"></slot></a>
      </h1>
      
      <slot name="intro" v-cloak></slot>
   </div>

</template>
<script>
   export default {
      name: "intro",
      components: { 
      },   
      props: {

         full: {
            type: Boolean,
            default: false
         }       
      },
      methods: {
      }
   };

</script>
<style>
[v-cloak] {
  display: none;
}
</style>
